export default __webpack_public_path__ + "static/media/photo--sm--wheel-3.5ff51ac4.jpg";